import { Record } from 'immutable';
const CreateArticleRequestStatusRecord = Record({
  error: undefined,
  isCreating: false
});
export default CreateArticleRequestStatusRecord;